import type { Agent } from '../types.ts'
import { defaultAgentModel } from '../../../shared/codexModels.ts'
import { useLive } from '../store.ts'

export function AgentModels({ agent }: { agent: Agent }) {
  const runners = useLive((s) => s.runners)
  const settings = useLive((s) => s.settings)
  const preferred = defaultAgentModel(agent, runners, settings ?? undefined)
  const active = agent.active_models ?? []
  const cls = 'max-w-full truncate rounded-[5px] border border-line bg-surface-2 px-1.5 font-mono text-[11px] leading-[18px] text-muted'
  return <>
    <span className={cls} title="Модель по умолчанию из общих настроек. При недоступности основного движка разрешённый резерв может использовать другую модель.">
      {preferred.provider === 'codex' ? 'Codex' : 'Claude'} · {preferred.model}
    </span>
    {active.filter((m) => m.provider !== preferred.provider || m.model !== preferred.model).map(({ provider, model }) => (
    <span key={`${provider}:${model}`} className={cls} title="Фактическая модель выполняющегося запуска">
      Сейчас: {provider === 'codex' ? 'Codex' : 'Claude'}{model ? ` · ${model}` : ''}
    </span>
    ))}
  </>
}
